import 'css-chunksrc/client/scenes/eventRemoval/styles.scss';export default {
  "header": "_header_jeqlk_1",
  "group": "_group_jeqlk_5",
  "text": "_text_jeqlk_9",
  "name": "_name_jeqlk_14",
  "main": "_main_jeqlk_20",
  "buttons": "_buttons_jeqlk_27"
};